export default class Matrix {
  public readonly m = new Array<number>(16);

  public setFromYawPitchRoll(yaw: number, pitch: number, roll: number) {
    const cos_x = Math.cos(pitch);
    const cos_y = Math.cos(yaw);
    const cos_z = Math.cos(roll);
    const sin_x = Math.sin(pitch);
    const sin_y = Math.sin(yaw);
    const sin_z = Math.sin(roll);

    this.m[0] = cos_y * cos_z - sin_x * sin_y * sin_z;
    this.m[1] = -cos_x * sin_z;
    this.m[2] = sin_y * cos_z + sin_x * cos_y * sin_z;
    this.m[3] = 0.0;

    this.m[4] = cos_y * sin_z + sin_x * sin_y * cos_z;
    this.m[5] = cos_x * cos_z;
    this.m[6] = sin_y * sin_z - sin_x * cos_y * cos_z;
    this.m[7] = 0.0;

    this.m[8] = -cos_x * sin_y;
    this.m[9] = sin_x;
    this.m[10] = cos_x * cos_y;
    this.m[11] = 0.0;
  }

  public setTranslation(x: number, y: number, z: number) {
    this.m[12] = x;
    this.m[13] = y;
    this.m[14] = z;
    this.m[15] = 1.0;
  }

  public mulScale(x: number, y: number, z: number) {
    this.m[0] *= x;
    this.m[1] *= x;
    this.m[2] *= x;

    this.m[4] *= y;
    this.m[5] *= y;
    this.m[6] *= y;

    this.m[8] *= z;
    this.m[9] *= z;
    this.m[10] *= z;
  }
}
